import React from "react";
import { Button, Input, Modal } from "react-materialize";
import "../../styles/rating-modal.css";
import $ from "jquery";
import { notify } from "react-notify-toast";

export const CommentBlock = ({ index,title,callback }) => {
	const questionList = document.querySelector(`[name=question-${index + 1}`)
	return (
		<div id="comment-block">
			<span id="comment-title">
				<h5>{title}</h5>
			</span>
			<Input
				type="textarea"
				name={`question-${index+1}`}
				placeholder="Masukkan darimu menjadi bahan evaluasi kami"
				className="mb-0"
				onChange={(e)=>callback(e,questionList.value.length > 500 ? true:false)}
			/>
			{
				questionList ? (
					questionList.value.length <=500 ? (
						<p className="mb-0 mt-0">{questionList.value.length + '/500'}</p>
						) : (
						<div>
							<p className="mb-0 mt-0">{questionList.value.length + '/500'}</p>
							<p className="mb-0 mt-0" style={{color:'red'}}>Jawaban Anda melewati batas maksimal</p>
						</div>
					)
				) : ''
			}
		</div>
	);
};

class RefJournal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {}
		this.commentChange = this.commentChange.bind(this);
		this.handleSubmitReview = this.handleSubmitReview.bind(this);
	}

	componentDidMount() {
		setTimeout(() => {
			let { is_open, modal_name } = this.props;
			if (is_open) {
				$("#" + modal_name + "_button").trigger("click");
			}
		}, 500);
	}

	commentChange = (e, isLimit) => {
		const { name, value } = e.target;
		
		this.setState({ [name]: {
			value,
			isLimit
		} });
	};

	handleSubmitReview = e => {
		e.preventDefault();
		const { comment_specs, api_url, callback } = this.props;
		let params = []
		
		comment_specs.forEach((element,index) => {
			const questionList = document.querySelector(`[name=question-${index + 1}`)
			params.push({uuid:element.uuid, question: questionList.value})
			// params[element.name] = this.state[element.name];
		});
		
		for(let i in params){
			if(!params[i].question){
				return notify.show("Anda harus isi semua pertanyaan", "warning")
			}
			if(this.state[`question-${+i+1}`].isLimit){
				return notify.show("Jawaban Anda melebihi batas maksimal", "warning")
			}
		}

		$.ajax({
			url: api_url
	  ,   type: 'POST'
	  ,   contentType: 'application/json'
	  ,   data: JSON.stringify(params) //stringify is important
	  }).then(()=>{
		notify.show("Jawaban Anda Telah Terkirim","success")
		// window.location.reload()
		$(".top-right-button").find(".fa-close").trigger("click");
		callback()
	}).catch(error =>{
		notify.show(error.responseJSON.message,"warning")
	  })
	};

	render() {
		let {
			header,
			comment_specs,
			modal_name,
			voucher_used
		} = this.props;
		return (
			<div id="outer-rating-modal">
				<Modal
					id={modal_name + "_modal"}
					header={header}
					trigger={<Button id={modal_name + "_button"} className="hide" />}
					modalOptions={{ dismissible: false }}
				>
					{comment_specs &&
						comment_specs.map((spec,index) => (
							<CommentBlock
								index={index}
								title={spec.title}
								callback={this.commentChange}
							/>
						))}
					{/* <div id="comment-block">
						<span id="comment-title">
							<h5>Anda Peserta Kartu Prakerja?</h5>
						</span>
						<p id="comment-desc" style={{lineHeight:1.2, color:'#5a5a5a', marginBottom:5}}>
							Berikut langkah-langkah melihat kode voucher kursus di aplikasi Bukalapak:
						</p>
						<ol style={{color:'#5a5a5a',marginTop:0,paddingLeft:'15px'}}>
							<li>Pada halaman awal aplikasi <strong>Bukalapak</strong>, pilih menu 'Transaksi'</li>
							<li>Lihat di 'Tagihan', pilih voucher kursus untuk melihat kode voucher</li>
							<li>Pada halaman 'Detil Tagihan', klik 'Lihat Kupon'</li>
						</ol>
						<Input
							placeholder={'Kode Voucher dari Bukalapak'}
							onChange={this.commentChange}
							name={'voucher_code'}
							style={{marginBottom:0}}
							disabled={voucherValid}
							value={voucherValid ? voucher_used : this.state.voucher_code}
						/>
					</div> */}
					<div className="top-right-button">
						<a className="modal-close" onClick={this.handleCloseModal}>
							{" "}
							<i className="fa fa-close" />{" "}
						</a>
					</div>
					<Button id="rating-modal-button" onClick={this.handleSubmitReview}>
						{" "}
						Kirim{" "}
					</Button>
				</Modal>
			</div>
		);
	}
}

export default RefJournal;



// WEBPACK FOOTER //
// ./src/components/Reuseables/RefJournals.js